import { useCurrentBox } from "@modules/box/useBox"
import { BoxStaffPermissions } from "@modules/boxStaff/gateway/boxStaffDto"
import { useBoxStaffPermission } from "@modules/boxStaff/hooks/useBoxStaffPermissions"
import { word } from "@modules/core/utils/i18n"
import { TransactionsDetailsContainer } from "@modules/finances/components/transactionsDetailsContainer"
import { useTransactionDetails } from "@modules/finances/hooks/useFinance"
import { ApiFinanceType } from "@modules/finances/types/financesType"
import { HuAvatarCardSidebar } from "@modules/ui/components/huAvatarCardSidebar"
import { HUText } from "@modules/ui/components/huText"
import { LoadingSpinner } from "@modules/ui/components/loading"
import { useMemo } from "react"
import { useTheme } from "styled-components"

type TransactionsDetailsProps = {
  transactionId: string
}
export const BoxTransactionsDetailsLayout: React.FC<TransactionsDetailsProps> = ({ transactionId }) => {
  const { data: transactionDetails, isLoading } = useTransactionDetails(transactionId)
  const { result: box } = useCurrentBox()
  const canSeeMembers = useBoxStaffPermission(BoxStaffPermissions.SEE_MEMBERS)
  const theme = useTheme()

  const contactIsVisible = useMemo(() => {
    if (box === null) return true
    else return canSeeMembers
  }, [box, canSeeMembers])

  return (
    <div className="h-full" style={{ marginTop: "-85px" }}>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <HuAvatarCardSidebar
            id={transactionDetails?.user.id}
            avatar={transactionDetails?.user.avatar ?? undefined}
            firstname={transactionDetails?.user.firstname}
            lastname={transactionDetails?.user.lastname}
            username={transactionDetails?.user.username}
            prefixUsername={transactionDetails?.user.username ? "@" : undefined}
            email={transactionDetails?.user.email}
            isLoading={isLoading}
            canUseContact={contactIsVisible}
          />
          {contactIsVisible ? (
            <div className="flex flex-column">
              <div className="flex justify-content-center mt-4 align-items-baseline">
                <HUText color={theme.neutralColor700} fontStyle="TM" className="mr-1">
                  {`${word("global.email")} :`}
                </HUText>
                <HUText color={theme.neutralColor600} fontStyle="BM" style={{ lineHeight: "23px" }}>
                  {`${transactionDetails?.user.email}`}
                </HUText>
              </div>
            </div>
          ) : null}
          {transactionDetails && (
            <TransactionsDetailsContainer transactionDetails={transactionDetails} apiFinanceType={ApiFinanceType.BOX} />
          )}
        </>
      )}
    </div>
  )
}
